import {Fragment} from 'react';
import {Seekbar} from '@common/player/ui/controls/seeking/seekbar';
import {FormattedCurrentTime} from '@common/player/ui/controls/formatted-current-time';
import {FormattedPlayerDuration} from '@common/player/ui/controls/formatted-player-duration';
import clsx from 'clsx';

interface Props {
  timeClassName?: string;
  className?: string;
  variant?: 'default' | 'fullscreen' | 'overlay';
}

export function MainSeekbar({
  timeClassName,
  className,
  variant = 'default',
}: Props) {
  const isFullscreen = variant === 'fullscreen';
  const isOverlay = variant === 'overlay';

  const timeClass = clsx(
    'min-w-44 flex-shrink-0 tabular-nums',
    isFullscreen &&
      'text-sm font-semibold text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)] md:text-base',
    isOverlay && 'text-sm font-medium text-main md:text-base',
    !isFullscreen && !isOverlay && 'text-xs text-muted',
    timeClassName,
  );

  return (
    <Fragment>
      <div
        className={clsx(
          'flex items-center',
          isFullscreen ? 'gap-14 md:gap-16' : 'gap-12',
          className,
        )}
      >
        <div className={clsx(timeClass, 'text-right')}>
          <FormattedCurrentTime />
        </div>
        <Seekbar
          className="flex-auto"
          trackColor={
            isFullscreen ? 'bg-white/30' : isOverlay ? 'neutral' : 'neutral'
          }
          fillColor={isFullscreen || isOverlay ? 'primary' : undefined}
        />
        <div className={timeClass}>
          <FormattedPlayerDuration />
        </div>
      </div>
    </Fragment>
  );
}
